var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"col-md col-xl-1 text-center",class:_vm.classDiv},[_c('span',{staticClass:"display-3 counter-anim",class:_vm.classSpan},[_vm._v(_vm._s(_vm.countNum))]),_c('small',{staticClass:"d-block"},[_vm._v(_vm._s(_vm.countText))])])
}
var staticRenderFns = []

export { render, staticRenderFns }